if (jQuery('.image-gallery-slick-inner').length > 0) {
  jQuery('.image-gallery-slick-inner').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: false,
    appendArrows: jQuery('.image-gallery-slick-arrows'),
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fa fa-angle-right"></i></button>'
  });
}